<template>
  <div class="const">
    <div class="sear">
      <label>分类:</label>
      <el-select v-model="fenleivalue" placeholder="请选择">
        <el-option
          v-for="item in leiOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <label>从</label>
      <el-date-picker v-model="startDate" type="date" placeholder="选择日期" style="width:150px"></el-date-picker>
      <label>到</label>
      <el-date-picker v-model="endDate" type="date" placeholder="选择日期" style="width:150px"></el-date-picker>
      <el-button type="primary" style="margin-left:20px;" v-on:click="tionSears()">确定</el-button>
    </div>
    <div
      class="jtCon"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.3)"
    >
      <div class="jtCons" v-for="item in videoLIst" v-bind:key="item.id">
        <div class="jtCon_pic" v-on:mouseover="true?'on':''" v-on:mouseout="true?'':'on'">
          <div class="demo-image__preview">
            <el-image :src="item.r_data" :preview-src-list="srcList" style="height:150px;"></el-image>
          </div>
        </div>
        <div class="jtCon_tit">{{item.r_title}}</div>
        <div class="jtCon_date">{{item.r_time}}</div>
      </div>
    </div>
    <el-pagination
      small
      layout="prev, pager, next"
      :total="total"
      :page-size="pagesize"
      @current-change="handleCurrentChange"
    ></el-pagination>
  </div>
</template>
<script>
import { http } from "./../../https";
export default {
  data() {
    return {
      startDate: "",
      endDate: "",
      videoLIst: [],
      srcList: [],
      leiOptions: [
        {
          label: "所有",
          value: "1"
        },
        {
          label: "聊天",
          value: "2"
        },
        {
          label: "邮件",
          value: "3"
        },
        {
          label: "论坛",
          value: "4"
        },
        {
          label: "微博",
          value: "5"
        },
        {
          label: "招聘求职",
          value: "6"
        },
        {
          label: "搜索",
          value: "7"
        },
        {
          label: "电影",
          value: "8"
        },
        {
          label: "游戏",
          value: "9"
        },
        {
          label: "购物",
          value: "10"
        },
        {
          label: "下载",
          value: "11"
        },
        {
          label: "QQ聊天",
          value: "12"
        },
        {
          label: "阿里旺旺",
          value: "13"
        },
        {
          label: "钉钉",
          value: "14"
        },
        {
          label: "SKYPE",
          value: "15"
        },
        {
          label: "LINE",
          value: "16"
        },
        {
          label: "微信",
          value: "17"
        }
      ],
      fenleivalue: "所有",
      page: 0,
      pagesize: 8,
      total: 0,
      loading: false
    };
  },
  created() {
    let timeStamp = new Date(new Date().setHours(0, 0, 0, 0)) / 1000;
    let SevenDayAgo = timeStamp - 86400 * 7;
    let start_time = SevenDayAgo;
    this.startDate = this.timestampToTime(start_time);
    let end_time =
      new Date(new Date().setHours(23, 59, 59, 0)).getTime() / 1000;
    this.endDate = this.timestampToTime(end_time);
    this.tionSear();
  },
  methods: {
    tionSears() {
      this.page = 0;
      this.tionSear();
    },
    tionSear() {
      const user_name = sessionStorage.getItem("user_name");
      const mac = sessionStorage.getItem("mac");
      const oauth_token = sessionStorage.getItem("oauth_token");
      this.loading = true;
      const type = 0;
      let subtype = 0;
      if (this.fenleivalue == "所有") {
        subtype = 1;
      } else {
        subtype = this.fenleivalue;
      }
      let macSplit = mac.replace(/-/g, "");
      let start_time = new Date(this.startDate).getTime() / 1000;
      let end_time = new Date(this.endDate).getTime() / 1000;
      const page = this.page;
      const pageSize = this.pagesize;
      let url = `http://${user_name}_${macSplit}.ng.360mon.cn:90/index.php?class=record&act=getLogRecord&mac=${mac}&oauth_token=${oauth_token}&type=${type}&subtype=${subtype}&page=${page}&page_count=${pageSize}&start_time=${start_time}&end_time=${end_time}`;
      http({
        method: "GET",
        url: url,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        }
      })
        .then(res => {
          if (res.data.table.length > 0) {
            this.srcList = [];
            for (let o of res.data.table) {
              o.r_data = `http://${user_name}_${macSplit}.ng.360mon.cn:90/${o.r_data}`;
              o.r_time = this.timestampToTime(o.r_time);
              this.srcList.push(o.r_data);
            }
          }
          this.loading = false;
          this.videoLIst = res.data.table;
          this.total = res.data.total;
        })
        .catch(res => {
          this.loading = false;
          console.log(res);
        });
    },
    handleCurrentChange(e) {
      this.page = e - 1;
      this.tionSear();
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    }
  }
};
</script>
<style scoped>
.const /deep/.el-image-viewer__close {
  color: #ffffff !important;
}
.const /deep/.el-image__inner {
  width: auto;
}
.const {
  background: #ffffff;
  height: 100%;
  width: 100%;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  text-align: left;
  overflow: auto;
}
.const .sear {
  margin-left: 26px;
  font-size: 15px;
  font-weight: 400;
  color: rgba(141, 141, 141, 1);
  padding-top: 20px;
}
.const .sear label {
  margin: 0 15px;
}
.const .jtCon {
  display: flex;
  flex-wrap: wrap;
  align-items: start;
  justify-content: left;
  margin: 15px 26px 0 26px;
  height: calc(100vh - 350px);
  overflow: auto;
}
.const .jtCon .jtCons {
  text-align: center;
  margin: 50px 1.5% 0 1.5%;
  width: 22%;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.const .jtCon .jtCons.on {
  background: #000;
}
.const .jtCon .jtCon_pic {
  width: 100%;
}
.const .jtCon .jtCon_pic img {
  height: 161px;
}
.const .jtCon .jtCon_tit {
  margin-top: 11px;
  font-size: 15px;
  font-weight: 400;
  color: rgba(60, 60, 60, 1);
}
.const .jtCon .jtCon_date {
  margin-top: 5px;
  font-size: 13px;
  font-weight: 400;
  color: rgba(164, 164, 164, 1);
}
.const /deep/.el-pagination {
  margin-top: 15px;
  text-align: right;
  padding-bottom: 15px;
}
</style>